export const lobbyPages = ['Assigned', 'Assignment', 'Schedule', 'Estimates', 'Invoices'] as const;
export type LobbyPage = typeof lobbyPages[number];

export const scheduleTabs = ['All', 'Leads', 'Assessments', 'Jobs', 'Unavailable'] as const;
export type ScheduleTab = typeof scheduleTabs[number];

export const reportsPages = ['Overview', 'Transactions', 'Commissions', 'Tech Parts', 'Tips', 'Credit Card', 'Compare'] as const;
export type ReportsPages = typeof reportsPages[number];

export const reportsPaymentsTabs = ['All', 'Paid', 'Pending'] as const;
export type ReportsPaymentsTabs = typeof reportsPaymentsTabs[number];

export const reportsCommissionsTab = ['Pending', 'Paid'] as const;
export type ReportsCommissionsTab = typeof reportsCommissionsTab[number];

export const reportsTechPartsTab = ['Pending', 'Paid'] as const;
export type ReportsTechPartsTab = typeof reportsTechPartsTab[number];

export const reportsTipsTab = ['Pending', 'Paid'] as const;
export type ReportsTipsTab = typeof reportsTipsTab[number];

export const reportsCreditCardTab = ['Settled', 'Pending', 'Pre-chargebacks', 'Chargebacks', 'Refunds', 'Surcharge'] as const;
export type ReportsCreditCardTab = typeof reportsCreditCardTab[number];

export const assessmentsTabs = ['Upcoming', 'In Progress', 'Overdue', 'History'] as const;
export type AssessmentsTab = typeof assessmentsTabs[number];

export const estimatesTabs = ['Pending', 'Won', 'Declined', 'Canceled', 'Drafts'] as const;
export type EstimateTab = typeof estimatesTabs[number];

export const jobsTabs = ['Submitted', 'Pending', 'In Progress', 'Done', 'Issues', 'Canceled'] as const;
export type JobsTab = typeof jobsTabs[number];

export const invoicesTabs = ['Pending', 'Paid', 'Canceled', 'Drafts'] as const;
export type InvoicesTab = typeof invoicesTabs[number];

export type Page = 'Settings' | 'Items' | LobbyPage | ReportsPages;

export type Tab =
  ScheduleTab
  | AssessmentsTab
  | EstimateTab
  | JobsTab
  | InvoicesTab
  | ReportsPaymentsTabs
  | ReportsCommissionsTab
  | ReportsCreditCardTab
  | ReportsTipsTab
  | ReportsTechPartsTab;

export type AnyPage = Page | Tab;

export function pagePathToName(page: string) {
  if (page === 'pre-chargebacks')
    return 'Pre-chargebacks';
  const nameArr = page.split('-');
  return nameArr
    .map(part => (part.charAt(0).toUpperCase() + part.slice(1)))
    .join(' ') as AnyPage;
}

export function pageNameToPath(page: string) {
  const nameArr = page.split(' ');
  return nameArr
    .map(part => part.toLowerCase())
    .join('-');
}
